import messages from './cmsLifecycleConfirm.json' with { type: 'json' };

export const cmsLifecycleConfirmEn: Readonly<typeof messages> = messages;
